angular.module("bmp.standard.text.templates", ["main/bmp-standard-text-input/bmp-standard-text-input-modal.html", "main/bmp-standard-text-input/bmp-standard-text-input.html"]);

angular.module("main/bmp-standard-text-input/bmp-standard-text-input-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/bmp-standard-text-input/bmp-standard-text-input-modal.html",
    "<div aria-label=\"{{$ctrl.titleText}}\" role=\"dialog\">\n" +
    "    <div class=\"modal-header\">\n" +
    "        <span id=\"bmp-standard-text-input-modal-close\" class=\"sr-only\" data-translate=\"Bluemoon.Practice.Common.Actions.Close\"></span>\n" +
    "        {{$ctrl.titleText}}\n" +
    "        <button id=\"tasksDialog.close\"\n" +
    "            type=\"button\"\n" +
    "            class=\"close\"\n" +
    "            aria-labelledby=\"bmp-standard-text-input-modal-close\"\n" +
    "            data-ng-click=\"$ctrl.cancel()\"\n" +
    "            >&times;</button>\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\">\n" +
    "        <div bento-busy-loader=\"$ctrl.loading\">\n" +
    "            <div ng-form name=\"$ctrl.standardTextForm\" class=\"bmp-standard-text-froala\">\n" +
    "                <textarea\n" +
    "                    ng-if=\"!$ctrl.loading\"\n" +
    "                    class=\"text-small\"\n" +
    "                    froala=\"$ctrl.froalaOptions\"\n" +
    "                    name=\"standardTextFroala\"\n" +
    "                    ng-model=\"$ctrl.textValue\">\n" +
    "                </textarea>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"modal-footer\">\n" +
    "        <button id=\"tasksDialog.ok\"\n" +
    "                class=\"btn btn-primary\"\n" +
    "                data-ng-click=\"$ctrl.save()\" data-translate=\"Bluemoon.Practice.Common.Actions.Save\"></button>\n" +
    "        <button id=\"tasksDialog.ok\"\n" +
    "                class=\"btn btn-default\"\n" +
    "                data-ng-click=\"$ctrl.cancel()\" data-translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/bmp-standard-text-input/bmp-standard-text-input.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/bmp-standard-text-input/bmp-standard-text-input.html",
    "<div class=\"input-group bmp-input-group-icon-only\">\n" +
    "    <input autocomplete=\"off\" type=\"text\" class=\"form-control\"\n" +
    "           name=\"standardTextInputField\"\n" +
    "           data-qe-id=\"{{::$ctrl.name+'-input'}}\"\n" +
    "           id=\"{{::$ctrl.name}}\"\n" +
    "           ng-model=\"$ctrl.ngModel\"\n" +
    "           ng-change=\"$ctrl.ngChange({})\"\n" +
    "           ng-disabled=\"$ctrl.ngDisabled\"\n" +
    "           ng-required=\"$ctrl.ngRequired\"\n" +
    "           ng-readonly=\"$ctrl.ngReadonly\"\n" +
    "           bmp-tab-stop=\"$ctrl.tabStop\"\n" +
    "           bmp-select-on-focus=\"true\"\n" +
    "           />\n" +
    "    <span class=\"input-group-btn\">\n" +
    "        <button type=\"button\"\n" +
    "            style=\"z-index: 4\"\n" +
    "            class=\"btn btn-default\"\n" +
    "            data-qe-id=\"{{::$ctrl.name+'-more-icon'}}\"\n" +
    "            ng-disabled=\"$ctrl.ngDisabled || $ctrl.ngReadonly\"\n" +
    "            ng-click=\"$ctrl.open($event)\"\n" +
    "            bmp-tab-stop=\"$ctrl.tabStop\">\n" +
    "            <i class=\"bento-icon-more\" style=\"margin-right:0px;\"></i>\n" +
    "        </button>\n" +
    "    </span>\n" +
    "</div>\n" +
    "");
}]);
